import { queryOptions } from '@tanstack/react-query'
import { organizationFeatureConfigApi } from './api'

export const organizationFeatureConfigQueries = {
  all: () => ['organizationFeatureConfig'],
  retrieve: (orgId: string | undefined) =>
    queryOptions({
      queryKey: [...organizationFeatureConfigQueries.all(), orgId],
      queryFn: () => organizationFeatureConfigApi.retrieve(orgId!),
      enabled: Boolean(orgId),
    }),
}
